export const BID_CUT_REQUEST_CONFIG = {
  MAX_RETRIES: 3,
  BACKOFF_MS: 300,
  MAX_PENDING_DISPLAY: 10,
  HIGHLIGHT_DURATION_MS: 2000
} as const;

